<rv-sortable
  #listElement
  [sortableService]="sortableService"
  class="scrollable-list"
>
  @for (playlistItem of playlistItems; track playlistItem; let i = $index) {
    <div rvSortableItem class="list-group-item flex-row">
      <div class="row-entry playlist-row-entry tw-py-4">
        <rv-sortable-handle></rv-sortable-handle>
        <div
          class="playlist-row-content tw-flex tw-flex-row tw-items-center tw-w-full tw-justify-between tw-overflow-auto"
        >
          <div
            (click)="manage(playlistItem)"
            (keydown.enter)="manage(playlistItem)"
            (keydown.space)="$event.preventDefault(); manage(playlistItem)"
            role="button"
            class="u_clickable tw-ml-[5px] tw-w-3/4 xl:!tw-w-full tw-overflow-hidden"
            [ngClass]="{
              'not-apple-tv-compatible': !isAppleTVCompatible(playlistItem),
            }"
            tabindex="0"
          >
            @if (playlistItem.type !== 'presentation') {
              <p
                class="rv-link !tw-block u_remove-bottom tw-truncate tw-font-medium"
                id="playlistItemNameCell"
                title="{{ playlistItem.name }}"
              >
                {{ playlistItem.name }}
              </p>
            } @else {
              <p
                class="rv-link !tw-block u_remove-bottom tw-truncate tw-font-medium"
                id="presentationNameCell"
                [presentationName]="playlistItem.objectReference"
              >
                Presentation Item
              </p>
            }
            <p
              class="text-sm text-gray u_remove-bottom tw-pt-[2.5px] tw-truncate tw-overflow-hidden"
            >
              <span
                class="text-gray"
                [shown]="playlistService.hasInsecureUrl(playlistItem)"
                ><span class="text-danger tw-font-medium">Insecure URL</span> •
              </span>
              <span
                [innerHTML]="timelineDescription.updateLabel(playlistItem)"
              ></span>
              •
              {{
                playlistItem.playUntilDone
                  ? 'Play Until Done'
                  : playlistItem.duration + 's'
              }}
              • {{ playlistService.getItemTransition(playlistItem) }}
            </p>
          </div>
          @if (!isAppleTVCompatible(playlistItem)) {
            <span
              class="mr-3 mt-2"
              matTooltip="Not Apple TV Compatible"
              matTooltipPosition="below"
              runZone
            >
              <img
                src="../images/apple-tv-incompatible-icon.svg"
                alt="Not Apple TV Compatible"
                width="32"
                height="23"
              />
            </span>
          }
          <div
            class="tw-flex tw-flex-row tw-items-center tw-gap-[5px] tw-w-1/4 xl:!tw-w-1/5 tw-justify-end"
          >
            <button
              type="button"
              attr.aria-label="Duplicate Playlist item {{ i + 1 }}"
              class="btn-icon playlist-row-action p-0 tw-leading-none"
              id="duplicateButton"
              (click)="playlistService.duplicatePlaylistItem(playlistItem)"
            >
              <mat-icon class="gray-icon" svgIcon="duplicate"></mat-icon>
            </button>
            <button
              type="button"
              attr.aria-label="Remove Playlist item {{ i + 1 }}"
              class="btn-icon playlist-row-action p-0 tw-leading-none"
              [id]="'removeButton-' + i"
              (click)="remove(playlistItem, i)"
            >
              <mat-icon class="gray-icon" svgIcon="trash"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</rv-sortable>
